import React from 'react';

import { VideoBlock } from '../../_components/VideoBlock';
import { VideoBlockProps } from './types';

import classes from './index.module.scss';

export const VideoBlockGraphQL: React.FC<VideoBlockProps> = props => {
  const {
    id,
  } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <VideoBlock videoBlock={props} />
    </div>
  );
};

export default VideoBlockGraphQL;
